import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'src/app/core/models/role';
import { IUser } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { ClientService } from 'src/app/core/services/client.service';
import { CustomerService } from 'src/app/core/services/customer.service';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit {

  id: string;
  user: IUser;
  currentUser: IUser;
  invoices;
  togglePay = false;
  toggleAddInvoice = false;
  invoice: any;
  showMessage = false;
  page = 1;
  perPage = 10;

  get lower() {
    return this.perPage * (this.page - 1) + 1;
  }

  get upper() {
    return Math.min(this.perPage * this.page, this.invoices.count);
  }

  constructor(
    private clientService: ClientService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private customerService: CustomerService,
    private authService: AuthService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    console.log('snap ', this.route.snapshot.params)
    this.id = this.route.snapshot.params.customerId || this.route.snapshot.params.clientId;
    console.log(this.id)

    this.authService.LoggedinUser
      .subscribe(
        res => {
          this.currentUser = res;
        }
      );

    this.route.snapshot.params.customerId
      ? this.loadInvoices(this.customerService)
      : this.loadInvoices(this.clientService);
  }

  loadInvoices(service: CustomerService | ClientService) {
    service.getInvoices(this.id, this.page, this.perPage)
      .subscribe(
        res => {
          this.invoices = res;
          console.log(this.invoices)
        },
        err => { }
      );
  }

  createInvoice() {
    this.clientService.createInvoice(this.id)
      .subscribe(
        res => {

        },
        err => { }
      );
  }

  isPartialPaid(invoice): boolean {
    return +invoice.paidAmount !== 0 && !invoice.closed;
  }

  onPay(invoice) {
    this.invoice = invoice;
    this.togglePay = true;
  }
  
  payInvoice(form: NgForm) {
    this.togglePay = false;
    const amount = form.form.value.amount;
    const toPay = this.invoice.amount - this.invoice.credits - +this.invoice.paidAmount;

    if (!amount) {
      return;
    }

    if (amount < 0) {
      this.translate.get('errors.canNotEnterNegativeAmount').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }

    if (amount > toPay) {
      this.translate.get('invoice.amountError', { toPay: toPay }).subscribe((text: string) => {
        this.toastr.error(text);
      });
      return false;
    }
    

    this.clientService.payInvoice(this.id, this.invoice.id, amount)
      .subscribe(
        res => {
          this.loadInvoices(this.clientService);
          this.toastr.success('Success');
        },
        err => {
          switch (err.errorCode) {
            case 4000039:
              this.translate.get('invoice.amountError', { toPay: toPay }).subscribe((text: string) => {
                this.toastr.error(text);
              });
              break;
          }
        }
      );
  }

  closeInvoice() {
    const service = this.route.snapshot.params.customerId
      ? this.customerService
      : this.clientService;

    service.closeInvoice(this.id, this.invoice.id)
      .subscribe(
        res => {
          this.loadInvoices(service);
          this.togglePay = false;
          this.toastr.success('Success');
        },
        err => {
          this.togglePay = false;
        }
      );
  }

  onAddInvoice() {
    let openInvoice = this.invoices.results.some(invoice => invoice.paid === false);

    this.showMessage = openInvoice ? true : false;

    this.toggleAddInvoice = true;
  }

  newInvoice() {
    this.clientService.createInvoice(this.id)
      .subscribe(
        res => {
          this.toastr.success(`Invoice created.`);
          this.loadInvoices(this.clientService);
          this.toggleAddInvoice = false;
        },
        err => {
          this.toggleAddInvoice = false;
        }
      );
  }

  changePerPage(event) {
    this.perPage = event.target.value;

    this.route.snapshot.params.customerId
      ? this.loadInvoices(this.customerService)
      : this.loadInvoices(this.clientService);
  }

  jumpToPage(event: any) {
    this.page = event;

    this.route.snapshot.params.customerId
      ? this.loadInvoices(this.customerService)
      : this.loadInvoices(this.clientService);
  }
}
